var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-table",
    {
      staticClass: "table",
      attrs: {
        multiple: _vm.multiple,
        "no-data-text": "No tienes documentos relacionados",
        data: _vm.relatedDocuments
      },
      scopedSlots: _vm._u([
        {
          key: "default",
          fn: function(ref) {
            var data = ref.data
            return _vm._l(data, function(tr, indextr) {
              return _c(
                "vs-tr",
                { key: indextr, attrs: { data: tr } },
                [
                  _c("vs-td", { attrs: { data: data[indextr].type } }, [
                    _vm._v(" " + _vm._s(_vm.findLabelDocument(tr.type)) + " ")
                  ]),
                  _c("vs-td", { attrs: { data: data[indextr].number } }, [
                    _vm._v(" " + _vm._s(tr.number) + " ")
                  ])
                ],
                1
              )
            })
          }
        }
      ]),
      model: {
        value: _vm.relatedDocumentsSelected,
        callback: function($$v) {
          _vm.relatedDocumentsSelected = $$v
        },
        expression: "relatedDocumentsSelected"
      }
    },
    [
      _c(
        "template",
        { slot: "thead" },
        [
          _c("vs-th", [_vm._v("Relacionado con")]),
          _c("vs-th", [_vm._v("Nº Documento")])
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }